import axios from "axios"
import * as env from "../constants/env"


/* List Card — the deck is 52 rows and never grows, so it arrives without pages */
export const list = () => {
    const uri = `${env.startpoint}card/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Edit Card */
export const edit = (data) => {
    const uri = `${env.startpoint}card/edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
